import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { CustomerStoreModule } from './module';

export const CustomerModule = getModule(CustomerStoreModule, store);
